var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M19-5H-5v24h24z","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"m.371 7.058 5.621 6.558L7.294 12.5 3.362 7.914l10.138.001V6.201L3.362 6.2l3.932-4.584L5.992.5z","key":1})]));
}

ArrowLeft.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
